<script lang="ts">
	import { onMount } from 'svelte'
	import * as GMaps from '@googlemaps/js-api-loader'
	// @ts-ignore
	const { Loader } = GMaps?.default ?? GMaps

	interface Props {
		apiKey: string
		onready: (sdk: typeof google) => void
	}

	let { apiKey, onready }: Props = $props()

	onMount(() => {
		new Loader({
			apiKey: apiKey,
			version: 'weekly',
			libraries: ['places'],
		})
			.load()
			.then((sdk) => {
				onready(sdk)
			})
			.catch((error) => {
				console.error('Failed to load Google Maps SDK:', error)
			})

		// No cleanup needed as the SDK should persist
	})
</script>
